<template>
  <!-- Change viewBox and fill params -->
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 32 32"
  >
    <g class="fill-current">
      <path
        d="M30.102 7.371c-0.378 0.002-0.727 0.121-1.014 0.324l0.006-0.004-6.070 3.864v-3.31c-0.064-1.475-1.276-2.647-2.761-2.647-0.036 0-0.072 0.001-0.108 0.002l0.005-0h-17.293c-0.032-0.001-0.069-0.002-0.106-0.002-1.485 0-2.697 1.172-2.761 2.641l-0 0.006v15.962c0.064 1.475 1.276 2.647 2.761 2.647 0.037 0 0.075-0.001 0.112-0.002l-0.005 0h17.293c0.032 0.001 0.069 0.002 0.106 0.002 1.485 0 2.697-1.172 2.761-2.641l0-0.006v-3.309l6.066 3.869c0.282 0.197 0.632 0.315 1.010 0.315 0.969 0 1.756-0.776 1.774-1.741l0-0.002v-14.219c-0.006-0.967-0.792-1.749-1.76-1.749-0.005 0-0.010 0-0.015 0h0.001zM21.253 24.206c-0.071 0.499-0.495 0.879-1.008 0.879-0.031 0-0.062-0.001-0.092-0.004l0.004 0h-17.29c-0.026 0.002-0.057 0.004-0.088 0.004-0.513 0-0.938-0.38-1.008-0.874l-0.001-0.005v-15.962c0.071-0.499 0.495-0.879 1.008-0.879 0.031 0 0.062 0.001 0.092 0.004l-0.004-0h17.293c0.026-0.002 0.057-0.004 0.088-0.004 0.513 0 0.938 0.38 1.008 0.874l0.001 0.005v15.962zM30.107 23.338l-0.067-0.072-7.016-4.472v-5.141l7.085-4.51z"
      ></path>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    }
  }
}
</script>
